import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import { noop } from 'lodash';
import { Link } from 'react-router-dom';
import looppa from 'looppa';
import FlipMove from 'react-flip-move';
import Icon from 'components/icon';
import { breadcrumbsDelay, breadcrumbsEasingFn, breadcrumbsSpeed } from 'constants/transitions-props';
import normaliseTrailingSlash from 'util/misc/normalise-trailing-slash';

class Breadcrumbs extends PureComponent {
    static propTypes = {
        breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.any.isRequired,
            url: PropTypes.string,
            action: PropTypes.func,
        })).isRequired,
    };

    static renderLink({ action, url, name }) {
        const icon = <Icon className="breadcrumbs--icon" symbol="chevron-left" size="small"/>;
        if (url) {
            return (
                <Link onClick={ action || noop } className="breadcrumbs--link u-reset" itemProp="url"
                    to={ normaliseTrailingSlash(url) }>
                    { icon }
                    <span className="breadcrumbs--text">
                        { name }
                    </span>
                </Link>
            );
        }

        return (
            <div onClick={ action || noop } className="breadcrumbs--link u-reset">
                { icon }
                <span className="breadcrumbs--text">
                    { name }
                </span>
            </div>
        );
    }

    get enterAnimation() {
        return {
            from: {
                transform: 'translate(32px, 0)',
                opacity: '0',
            },
            to: {
                transform: '',
                opacity: '',
            },
        };
    }

    get leaveAnimation() {
        const { from, to } = this.enterAnimation;

        return {
            from: to,
            to: from,
        };
    }

    render() {
        const { breadcrumbs } = this.props;
        return (
            <nav className="breadcrumbs grid" aria-label="Breadcrumbs">
                <div className="breadcrumbs--container grid--container">
                    <FlipMove
                        enterAnimation={ this.enterAnimation }
                        leaveAnimation={ this.leaveAnimation }
                        typeName="ol"
                        maintainContainerHeight={ true }
                        delay={ breadcrumbsDelay }
                        duration={ breadcrumbsSpeed }
                        easing={ breadcrumbsEasingFn }
                        className="breadcrumbs--list u-reset">
                        { looppa(breadcrumbs)(({ url, name, action }, i) => (
                            <li itemScope itemType="http://data-vocabulary.org/Breadcrumb" className="breadcrumbs--item"
                                key={ i }>
                                { Breadcrumbs.renderLink({ url, name, action: action || noop }) }
                            </li>
                        )) }
                    </FlipMove>
                </div>
            </nav>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        breadcrumbs: 'breadcrumbs.items',
    }),
    reduxUtils.mapDispatchToProps({}),
)(Breadcrumbs);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/breadcrumbs/index.js